type TWidgetHeadlineProps = {
  headline: string;
};
export const WidgetHeadline: React.FC<TWidgetHeadlineProps> = ({
  headline,
}) => {
  return <div className="bg-border p-1 rounded-t-md mt-1">{headline}</div>;
};
